export default {"src":"/_next/static/media/dummy-user.545d0620.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};